define(["require", "exports", "../Utils", "azure-devops-ui/Core/Util/String"], function (require, exports, Utils_1, String_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function getServiceItems(serviceList) {
        var items = [];
        serviceList.forEach(function (service) {
            items.push({
                package: service.metadata.name,
                type: service.spec.type,
                clusterIP: service.spec.clusterIP || "-",
                externalIP: _getExternalIP(service),
                port: _getPort(service) || "",
                creationTimestamp: service.metadata.creationTimestamp || new Date(),
                uid: service.metadata.uid.toLowerCase(),
                pipeline: Utils_1.Utils.getPipelineText(service.metadata.annotations),
                service: service,
                kind: service.kind || "Service"
            });
        });
        return items;
    }
    exports.getServiceItems = getServiceItems;
    function _getPort(service) {
        if (service.spec
            && service.spec.ports
            && service.spec.ports.length > 0) {
            var ports = service.spec.ports.map(function (port) { return _formatPortString(port); });
            return ports.join(", ");
        }
        return "";
    }
    function _formatPortString(servicePort) {
        var nodePort = servicePort.nodePort ? ":" + servicePort.nodePort : "";
        // example: 80:2080/TCP, if nodeport. 80/TCP, if no nodeport
        return String_1.localeFormat("{0}{1}/{2}", servicePort.port, nodePort, servicePort.protocol);
    }
    function _getExternalIP(service) {
        return service.status
            && service.status.loadBalancer
            && service.status.loadBalancer.ingress
            && service.status.loadBalancer.ingress.length > 0
            && service.status.loadBalancer.ingress[0].ip
            || "";
    }
});
